// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tod-right[data-v-18e2e240]{position:fixed;padding:0 10px;right:2px;width:230px;top:2px;bottom:2px;z-index:9;background-color:rgba(128,134,149,.3);overflow-y:scroll;scrollbar-width:none;-ms-overflow-style:none}.tod-right[data-v-18e2e240]::-webkit-scrollbar{display:none}", ""]);
// Exports
module.exports = exports;
